import React, { FC } from 'react'
import {
  FormControl,
  FormLabel,
  Input,
  Text,
  FormControlProps,
  FormErrorMessage,
  Flex,
  Textarea
} from '@chakra-ui/react'
import { FieldHookConfig, FieldInputProps, useField } from 'formik'

export type TextFieldProps = {
  label?: string
  maxLength?: number
  readOnly?: boolean
} & FieldHookConfig<string>




const MultiLineTextInput: FC<TextFieldProps> = ({
  maxLength = 500,
  label = '',
  readOnly = false,
  ...props
}) => {
  const [field, meta] = useField(props)

  return (
    <FormControl isDisabled={props.disabled} isInvalid={meta.touched && !!meta.error}>
      <Flex alignItems={'center'} gap={'10px'} mb={'2px'}>
        <FormLabel
          id={`${props.name}-label`}
          htmlFor={`${props.name}-input`}
          fontSize={'small'}
          m={0}
        >
          {label}
        </FormLabel>
      </Flex>
      <Textarea
        {...field}
        readOnly={readOnly}
        // type={props.type || 'text'}
        id={`${props.name}-input`}
        variant="outline"
        placeholder={props.placeholder}
        spellCheck={false}
        maxLength={maxLength}
        fontSize={'sm'}
        focusBorderColor="brand.primary"
        resize = {'none'}
      ></Textarea>
      {meta.error && (
        <FormErrorMessage fontSize={'x-small'} m={0}>
          {meta.error}
        </FormErrorMessage>
      )}
    </FormControl>
  )
}

export default MultiLineTextInput
